import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "../config/backend";
import "./css/OrdersModule.css";

const OrdersModule = () => {
    const [orders, setOrders] = useState([]);
    const [message, setMessage] = useState("");
    const token = localStorage.getItem("_crm__token");

    useEffect(() => {
        fetchOrders();
        // eslint-disable-next-line
    }, []);

    const fetchOrders = async () => {
        setMessage("");
        try {
            const res = await axios.post(`${api}/Admin/getorders`, { token });
            if (res.data.success) {
                setOrders(res.data.data);
            } else {
                setMessage(res.data.message || "Failed to fetch orders");
            }
        } catch {
            setMessage("Error fetching orders");
        }
    };

    return (
        <div className="orders-module-container">
            <h2>Orders</h2>
            {message && <div className="orders-message">{message}</div>}
            <div className="orders-table-container">
                <table className="orders-table">
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Client Name</th>
                            <th>Employee</th>
                            <th>Total Price</th>
                            <th>Order Date</th>
                            <th>Products</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.length === 0 ? (
                            <tr>
                                <td colSpan={6} style={{ textAlign: "center" }}>
                                    No orders found.
                                </td>
                            </tr>
                        ) : (
                            orders.map((order) => (
                                <tr key={order._id}>
                                    <td>{order._id.slice(-6).toUpperCase()}</td>
                                    <td>{order.leadId?.clientname || "-"}</td>
                                    <td>{order.EmployeeId?.Name || "-"}</td>
                                    <td>₹{order.TotalPrice}</td>
                                    <td>
                                        {new Date(order.createdAt).toLocaleString("en-IN", {
                                            dateStyle: "medium",
                                            timeStyle: "short",
                                        })}
                                    </td>
                                    <td>
                                        {order.Products.map((prod, idx) => (
                                            <div key={prod._id}>
                                                <b>{prod.packageId?.productId?.productname || "-"}</b>
                                                {prod.packageId?.name ? (
                                                    <> ({prod.packageId.name})</>
                                                ) : null}
                                                , Qty: {prod.quantity}
                                                <br />
                                            </div>
                                        ))}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default OrdersModule;
